import WordService from '_services/rest/modules/word';

export default {
  state: {
    word: null,
    wordsList: null,
  },
  mutations: {
    setWord(state, response) {
      state.word = response;
    },
    setWordList(state, response) {
      state.wordsList = response;
    },
  },
  actions: {
    getWords({ commit }) {
      WordService.getWords()
        .then(response => {
          commit('setword', response);
        });
    },
    getWordsList({ commit }, params) {
      WordService.getWords(params)
        .then(response => {
          commit('setWordList', response);
        });
    },
  },
};
